<template>
  <div class="hello">
   

    <div class="articleTitle">
      <span>{{ model.title }}</span>
    </div>
    <div class="articleSource">
      <span class="span_1">{{ model.articleSource }}</span>
      <span class="span_2">{{ model.createTimestamp | yq_formatTime }}</span>
    </div>

    <div class="article_content" v-if="model.hasSelf===0">
      <ol>
        <div v-for="(item, index) in contentObjects" :key="index">
          <div v-if="item.type === 'empty'" class="content-empty"/>
          <div v-if="item.type==='text'" class="content-text" v-html="item.data">
          </div>
          <img v-if="item.type==='img'" :src="item.data" referrerpolicy="no-referrer"/>
          <video
            style='object-fit: cover'
            @play="videoPlay"
            v-if="item.type ==='video'"
            :id="item.url"
            class="video-js video"
            :poster="item.data.cover_img"
            controls
          >
            <source
              :src="item.data.url"
              type="video/mp4"
            >
          </video>
        </div>
      </ol>
    </div>
    <div class="self-content" v-if="model.hasSelf===1">
        <div v-for="(item,index) in richData.blocks" :key="index">
          <div v-if="item.type=='unstyled'" v-html="item.text" class="content-text">

          </div>
          <div v-if="item.type=='atomic'">
                <img v-if="richData.entityMap[item.entityRanges[0].key].type=='IMAGE'" :src="richData.entityMap[item.entityRanges[0].key].data.url"/>
                <div v-if="richData.entityMap[item.entityRanges[0].key].type=='VIDEO'">
                <video
            style='object-fit: cover'
            @play="videoPlay"
            v-if="richData.entityMap[item.entityRanges[0].key].type==='VIDEO'"
            :id="richData.entityMap[item.entityRanges[0].key].data.url"
            :poster="richData.entityMap[item.entityRanges[0].key].data.link"
            class="video-js video"
            controls
          >
            <source
              :src="richData.entityMap[item.entityRanges[0].key].data.url"
              type="video/mp4"
            >
          </video>
          </div>
          </div>

        </div>
    </div>


  
  </div>
</template>

<script>
// 资讯详情
import open_app from '../../static/img/h5_open_app.png'
import api from '../utils/api'
import wx from 'weixin-js-sdk'
import dateUtil from '../utils/dateUtil'

export default {
  name: 'SkillCodeArticleDetail',
  props: {
    // 隐藏底部按钮
    hiddenBtn: {type: Boolean, default: false},
    // 新闻id,只有作为组件的时候才用到,否则用路由自带的newsId
    newsId: String,
  },
  computed: {
    // 图片
    images: function () {
      const newsImages = this.model.newsImg ? this.model.newsImg : ''
      return newsImages.split(',')
    },
  },
  data () {
    return {
      model: {
        content: '',
        title: '',
        newsImg: '',
        articleSource: '',
        createTime: '',
        videoList: [],
      },
      richData:{

      },
      onPullDown: true,
      localImg: open_app,
      recommendList: [],
      videoCount: 0,

      scanIndex: 0,
      scannedTag: false,
      scannedPTag: false,
      lastStringLocation: 0,
      imageIndex: 0,
      videoIndex: 0,
      contentObjects: [],
      players: [],
      currentPlayer: undefined,
    }
  },
  mounted () {
    this.request()
    window.addEventListener('scroll', this.scroll, false)
  },
  destroyed () {
    window.removeEventListener('scroll', this.scroll) //  离开页面清除（移除）滚轮滚动事件
  },
  methods: {
    addVideoCount: function (size) {

      this.videoCount = this.videoCount + size


      return ''
    },
    videoPlay (event) {
      if (this.currentPlayer && this.currentPlayer !== event.target) {
        this.currentPlayer.pause()
      }
      this.currentPlayer = event.target
    },
    initVideo () {
      //初始化视频方法 循环列表获取每个视频的id
      this.players = this.model.videoList.map((item, index) => {
        return this.$video(item.url, {
          //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
          controls: true,
          //自动播放属性,muted:静音播放
          autoplay: 'muted',
          //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
          preload: 'auto',
          //设置视频播放器的显示宽度（以像素为单位）
          width: '500px',
          //设置视频播放器的显示高度（以像素为单位）
          height: '300px',
          //封面图
          // poster: item.cover_img
        })
      })
    },
    scanTag (result, content) {
      for (let i = 0; i < content.length; i++) {
        // 获取当前字符
        const currentChar = content[i]
        switch (currentChar) {
          // 带标签的情况
          case '<':
            if (content.substr(i, 3) === '<p>') {
              this.scanAddText(result, content, i)
              this.scanAddEmpty(result)
              // this.scanIndex += 3
              this.scanIndex = i + 3
              this.lastStringLocation = this.scanIndex
              continue
            }
            if (content.substr(i, 5) === '<img>') {
              this.scanAddText(result, content, i)
              this.scanAddEmpty(result)
              this.scanAddImg(result)
              this.scanAddEmpty(result)
              // this.scanIndex += 5
              this.scanIndex = i + 5
              this.lastStringLocation = this.scanIndex
              continue
            }

            if (content.substr(i, 7) === '<video>') {
              this.scanAddText(result, content, i)
              this.scanAddEmpty(result)
              this.scanAddVideo(result)
              this.scanAddEmpty(result)
              // this.scanIndex += 7
              this.scanIndex = i + 7
              this.lastStringLocation = this.scanIndex
              continue
            }
            if (content.substr(i, 5) === '<end>') {
              this.scanAddText(result, content, i)
              // this.scanIndex += 7
              this.scanIndex = i + 5
              this.lastStringLocation = this.scanIndex
              continue
            }
            this.scanIndex += 1
            this.scannedTag = false
            this.scannedPTag = false
            continue
          default:
            // alert("文本")
            this.scanIndex += 1
            this.scannedTag = false
            this.scannedPTag = false
        }
      }
      // 经过上面的扫码,到这里已经到最后扫描处
    },

    scanAddEmpty (result) {
      // 如果前面已经标记为p标签了,不再添加
      if (this.scannedPTag === true) return
      result.push({type: 'empty'})
      this.scannedPTag = true
    },

    // 此方法为添加文本,会在每个标签之前调用
    scanAddText (result, content, currentIndex) {
      // 如果扫出来的是标签,则什么都不做(字符串会连续扫出来)
      if (this.scannedTag === true) return
      console.log('添加文本之前', this.scanIndex)
      // 文本为当前所在
      const text = content.substr(this.lastStringLocation, currentIndex - this.lastStringLocation)
      console.log('添加文本之后', text)
      // 添加文本对象
      result.push({type: 'text', data: text})
    },
    // 添加图片对象
    scanAddImg (result) {
      // 防止标签数大于数据源数
      if (this.imageIndex >= this.model.newsImg.length) {
        return
      }
      result.push({type: 'img', data: this.images[this.imageIndex]})
      this.imageIndex += 1
      this.scannedTag = true
      this.scannedPTag = false
    },
    scanAddVideo (result) {
      // 防止标签数大于数据源数
      if (this.videoIndex >= this.model.videoList.length) {
        return
      }
      const video = this.model.videoList[this.videoIndex]
      // video.id = this.videoIndex
      video.index = this.videoIndex
      result.push({type: 'video', data: video})
      console.log('添加视频结束', result)
      this.videoIndex += 1
      this.scannedTag = true
      this.scannedPTag = false
    },

    getTime (newsTime) {
      return dateUtil.handleDateWithTime(newsTime)
    },
    scroll () {
      if (!this.currentPlayer) {
        return
      }
      const box = this.currentPlayer.getBoundingClientRect()
      const offsetTop = (box.y + box.height) < 0
      const offsetBottom = box.y > document.documentElement.clientHeight
      console.log(offsetBottom)
      console.log(document.documentElement.clientHeight)
      if (offsetTop || offsetBottom) this.currentPlayer.pause()
    },

  
    isWeiXin () {
      const ua = navigator.userAgent.toLowerCase()
      return ua.indexOf('micromessenger') !== -1
    },
    isIos () {
      const ua = navigator.userAgent.toLowerCase()
      return ua.indexOf('iphone') > -1 || ua.indexOf('mac os') > -1
    },
    clickRecommend (entity) {
      api.optCallBack(entity.id, 'REC_CLICK')
      this.clickOpenApp(entity.news_id)
    },
    clickOpenApp (newsId) {
      if (this.model.id) {
        api.optCallBack(this.model.id, 'APP_CLICK')
      }
      this.openApp(newsId)
    },
    openApp (newsId) {
      if (this.isIos()) {
        // window.location.href = 'https://apps.apple.com/cn/app/id1566830507'
        const currentId = this.newsId ? this.newsId : this.$route.query.news_id
        const id = newsId ? newsId : currentId
        window.location.href = `https://ulink.yunquancn.com/wxshare/news?news_id=${id}`
      } else {
        // 这里举个美团的例子   imeituan://就是android和ios需要设置的scheme
        window.location.href = 'zjyopenapp://zjy?newsId=' + newsId
        // 这样如果你安装了app就可以成功唤醒app了
        // 这个延时就是在三秒没有反应跳到百度了，这里你可以写下载链接。或者引导用户下载。
        setTimeout(function () {
          let a = document.createElement('a')
          a.href = 'https://cdn.zjyjc.com/apk/教育圈.apk'
          a.click()
        }, 1000)
      }
    },
    getLogoImage () {
      return 'http://cdn.cbcnt.com/etop/img/420211124/30ad34aa23564313bcb440d4ecad23bc.png'
      // return 'https://cdn.edunetwork.cn/vb/oth/image/20211122/2fb9e179732a4925898d773481d617e2.png'
    },
    delHtmlTag (str) {
      return str.replace(/<[^>]+>/g, '').replace('<strong>', '') //去掉所有的html标记
    },
    // 请求,包含了新闻的信息以及获取微信的数据
    request () {
      const id = this.newsId ? this.newsId : this.$route.query.news_id
      this.newsId = id

      const url = window.location.href.split('#')[0]
      Promise.all([api.getNewsInfo(id), api.getWxInfo(url)]).then((res) => {
        const model = res[0]
        this.model = model
        let wxcontent = ""
        let imgUrl = ''
        let newsImagesString = ""
        if(model.hasSelf===1){
           this.richData=JSON.parse(model.content)
           this.richData.blocks.forEach((item,index)=>{
             if(item.type==="unstyled"){
                 wxcontent=wxcontent+item.text
             }else if(item.type==="atomic"){
                   if(this.richData.entityMap[item.entityRanges[0].key].type==="IMAGE"&&newsImagesString===""){
                       newsImagesString=this.richData.entityMap[item.entityRanges[0].key].data.url
                   }
             }
           })
        }else{
            wxcontent = this.delHtmlTag(model.content)
            newsImagesString = this.model.newsImg ? this.model.newsImg : ''
        }
        const wxInfo = res[1]

        if (newsImagesString !== null && newsImagesString !== '') {
          imgUrl = newsImagesString.split(',')[0]
        } else {
          imgUrl = this.getLogoImage()
        }
        wx.config({
          debug: false, // 开启调试模式,
          appId: wxInfo.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
          timestamp: wxInfo.timestamp, // 必填，生成签名的时间戳
          nonceStr: wxInfo.noncestr, // 必填，生成签名的随机串
          signature: wxInfo.sign, // 必填，签名，见附录1
          jsApiList: [
            'updateAppMessageShareData',
            'updateTimelineShareData',
            'onMenuShareAppMessage',
            'onMenuShareTimeline',
            'onMenuShareQQ',
            'onMenuShareQZone',
          ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })

        wx.updateTimelineShareData({
          title: model.title, // 分享标题
          link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: imgUrl, // 分享图标
          success: function () {
            // 设置成功
          },
        })

        wx.ready(function () {
          //需在用户可能点击分享按钮前就先调用
          console.log('验证成功')
          wx.updateAppMessageShareData({
            title: model.title, // 分享标题
            desc: wxcontent, // 分享描述
            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imgUrl, // 分享图标
            success: function () {
              // 设置成功
            },
          })
          wx.onMenuShareTimeline({
            title: model.title, // 分享标题
            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: imgUrl, // 分享图标
            success: function () {
              // 设置成功
            },
          })
        })

        wx.error(function (res) {
          console.log('验证失败')
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        })
        if(model.hasSelf===0){
         const result = []
        // 添加end标签主要是用于扫除前面的文字显示
        this.scanTag(result, model.content + '<end>')
        this.contentObjects = result
        }

        this.initVideo()
      })
    },
  },
}
</script>
<style scoped>
h1,
h2 {
  font-weight: bold;
  size: 0.46rem;
}

.articleTitle {
  font-weight: bold;
  font-size: 0.46rem;
  text-align: left;
  margin-right: 0.3rem;
  margin-left: 0.3rem;
  color: #000;
}

.articleSource {
  margin-top: 0.2rem;
  margin-left: 0.3rem;
  text-align: left;
}


.span_1 {
  font-size: 0.32rem;
  color: #5a7cab;
  font-weight: 400;
}

.span_2 {
  margin-left: 0.2rem;
  font-size: 0.26rem;
  color: #888;
  font-weight: 400;
}

ol {
  padding-left: 0.3rem;
  padding-right: 0.3rem;
  margin-top: 0rem;
  padding-top: 0rem;
}


li {
  flex: 1;
}

a {
  color: #42b983;
}

p {
  color: #1e1e1e;
  font-size: 0.34rem;
  text-align: left;
  width: 100%;
  line-height: 0.6rem;
  font-weight: normal;
  letter-spacing: 1px;
}

img {
  width: 100%;
}

.divide_line {
  clear: both;
  height: 0.1rem;
  background-color: #f7f7f7;
}

.recommenddivide_line {
  clear: both;
  margin-left: 0.3rem;
  margin-right: 0.3rem;
  height: 1px;
  box-shadow: inset 0px -1px 1px -1px #c8c7cc;
}

.img_1 {
  width: 3rem;
}

.img_2 {
  margin-right: 0.3rem;
  width: 2.24rem;
  height: 1.48rem;
  border-radius: 0.06rem;
}

.nav_open_app {
  width: 1.2rem;
  height: 0.52rem;
  margin-right: 0.3rem;
  margin-top: 0.08rem;
  text-align: center;
  float: right;
}

.img_logo {
  margin-left: 0.3rem;
  width: 0.68rem;
  height: 0.68rem;
  float: left;
}

.nav {
  margin-top: 0.3rem;
  width: 100%;
  height: 0.68rem;
  margin-bottom: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.nav_span {
  margin-left: 0.18rem;
  height: 0.68rem;
  text-align: left;
  font-size: 0.36rem;
  color: #000;
  font-weight: 500;
  line-height: 0.68rem;
  float: left;
}

.bottom_open_box {
  position: fixed;
  bottom: 0.3rem;
  width: 100%;
}

.center {
  /*设置显示样式**/
  display: flex;
  /**子view垂直居中*/
  align-items: center;
  /**垂直居中*/
  vertical-align: center;
  /**内容居中*/
  justify-content: center;
  /*子view排列方式row--水平 column--垂直*/
  flex-direction: column;
}

.marginLeftRight {
  margin-left: 0.2rem;
  margin-right: 0.2rem;
}

.grid {
  float: left;
  margin-top: 0.2rem;
}

.recommendList {
  /* clear: both; */
  display: block;
  background-color: white;
}

.title {
  /* clear: both; */
  margin-top: 0.8rem;
  margin-left: 0.3rem;
  margin-right: 0.3rem;
  font-weight: bold;
  color: #1e1e1e;
  font-size: 0.34rem;
  text-align: left;
}

.recommendList_title {
  /* clear: both; */

  margin-left: 0.3rem;
  margin-right: 0.3rem;
  color: #1e1e1e;
  font-size: 0.32rem;
  flex: 1;
  text-align: left;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.recommendList_content {
  display: inline-block;
  clear: both;
  padding-top: 0.3px;
  margin-left: 0.3rem;
  margin-right: 0.3rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  font-size: 0.3rem;
  text-align: center;
  line-height: 0.5rem;
  font-weight: normal;
  color: #666;
  letter-spacing: 1px;
}

.recommendList_span {
  clear: both;
  margin-top: 0.2rem;
  float: left;
  margin-left: 0.3rem;
  font-size: 0.24rem;
  color: #999;
}

.item {
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
  display: flex;
}

.right {
}

.left {
  flex: 1;
}


.recommendList_source {
  color: #999;
  font-size: 0.24rem;
}

.video-content {
  width: 100%;
  height: 56vw;
}

.video {
  width: 100%;
  height: 56vw;
}

.video::-webkit-media-controls-fullscreen-button {
  display: none;
}

.article_content {
  margin-top: 10px;
}

.self-content{
  margin-top: 10px;
  margin-left: 0.3rem;
  margin-right: 0.3rem;
  font-size: 0.34rem;
}

.content-text {
  font-size: 0.34rem;
  line-height: 0.68rem;
  text-align: left;
  color: #333333;
}

.content-empty {
  height: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/SkillCodeArticleDetail.vue